import { render } from "./DataFetchLoadingComponent.vue?vue&type=template&id=0e5d5b4f&scoped=true"
import script from "./DataFetchLoadingComponent.vue?vue&type=script&lang=js"
export * from "./DataFetchLoadingComponent.vue?vue&type=script&lang=js"

import "./DataFetchLoadingComponent.vue?vue&type=style&index=0&id=0e5d5b4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5d5b4f"]])

export default __exports__